import ApiService from '@/core/services/api.service';

export const SolutionService = {
  getAll(params = {}) {
    return ApiService.query(`v1/warranty/solutions`, { params });
  },

  getById(id) {
    return ApiService.get(`v1/warranty/solutions/${id}`);
  },

  create(data) {
    return ApiService.post('v1/warranty/solutions', data);
  },

  update(id, data) {
    return ApiService.put(`v1/warranty/solutions/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`v1/warranty/solutions/${id}`);
  },

  updateActiveStatus(id, isActive) {
    return ApiService.patch(`v1/warranty/solutions/${id}/active-status`, {
      isActive,
    });
  },
};
